import React from 'react'
import Preloader from '../../Global/Preloader';
import Headertwo from '../../Global/Headertwo';
import Servicedtlbred from '../Mainservicesdetails/Servicedtlbred';
import Servicesdetails from '../Mainservicesdetails/Servicesdetails';
import Ctaone from '../../Global/Ctaone';
import Footer from '../../Global/Footer';
import BackToTop from '../../Global/BackToTop';
import ContactForm from '../../Global/ContactForm';
import SecurityBanner from '../../Services/Servicesdetails/SecurityBanner';
import securityImage from '../../../assets/images/security.jpg';
import securityImage1 from '../../../assets/images/security-1.jpg';

const Main = () => {
    return (
        <>
            {/* <Preloader /> */}
            <Headertwo />
            {/* <Servicedtlbred title="Real Estate Management" /> */}
            <SecurityBanner />

            <section className="real-estate-details py-5">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left side: Text */}
                        <div className="col-xl-7 col-lg-10">
                            <h3 style={{ fontSize: '2.5em' }}>Protecting what matters most to you: Your loved ones, property, and peace of mind</h3>

                            <p>
                                Living abroad often comes with constant worry about the safety of your family and property back home. Whether it’s unauthorized property occupation, lack of surveillance, or concerns about loved ones’ security, NRIs face unique challenges when it comes to staying connected and protected.
                            </p>
                            
                            <p>
                                At The NRI Advisors, we offer comprehensive security solutions tailored for NRIs — including personal security, property surveillance, advanced tech monitoring systems, and even discreet detective services. Our mission is to provide complete peace of mind by safeguarding everything that matters to you, even while you're thousands of miles away.
                            </p>
                        </div>

                        {/* Right side: Image */}
                        <div className="col-xl-5 col-lg-8 ms-auto">
                            <img
                                src={securityImage1}
                                alt="Why Choose The NRI Advisors"
                                className="img-fluid rounded" style={{ width: '90%', marginBottom: '15px'}}
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="real-estate-details mb-5">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left side: Text */}
                        <div className="col-xl-12 col-lg-12">
                            <h3 style={{ fontSize: '2.5em' }}>We’re Here for You – Wherever You Are</h3>

                            <p><b>Your Security Team on the Ground — Vigilant, Responsive, and Reliable</b></p>

                            <p>
                                We are <b>The NRI Advisors</b>— a trusted name for NRIs across the globe who need reliable protection for their families, assets, and properties in India. Backed by trained security professionals, legal experts, and surveillance specialists, we offer round-the-clock support using both physical and technical solutions.
                            </p>
                            
                            <p>
                                From CCTV monitoring and personal guards to background checks and property visitations, we are your eyes and ears on the ground. Our goal is simple: <b>to keep your home and loved ones safe, so you can live and travel with confidence.</b>
                            </p>
                        </div>
                    </div>
                </div>
            </section>

           <section
            className="what-we-offer"
            style={{
                padding: '60px 0',
                backgroundColor: '#f9fafb',
                color: '#333',
                fontFamily: "'Roboto', sans-serif",
            }}
            >
            <div className="container">
                <h2
                className="section-title"
                style={{
                    fontSize: '2.8rem',
                    fontWeight: '700',
                    letterSpacing: '0.8px',
                    textAlign: 'center',
                }}
                >
                Our Services – Tailored for Every NRI Need
                </h2>

                <p style={{
                    fontSize: '1.4rem',
                    color: '#5A5A5A',
                    textAlign: 'center',
                    marginBottom: '25px',
                }}>Security Services for NRIs – Safe. Smart. Reliable.</p>

                <div className="row gx-5 gy-4">
                {[
                    {
                    icon: '🛡️',
                    title: 'Personal Security',
                    points: [
                        'Trained bodyguards & private security for safe travel and stay',
                    ],
                    },
                    {
                    icon: '📡',
                    title: 'Technical Security Solutions',
                    points: [
                        'Real-time CCTV, GPS tracking & remote monitoring systems',
                    ],
                    },
                    {
                    icon: '🕵️‍♂️',
                    title: 'Detective Services',
                    points: [
                        'Discreet background checks, surveillance & private investigations',
                    ],
                    },
                    {
                    icon: '🏠',
                    title: 'Property Surveillance',
                    points: [
                        '24x7 guarding & monitoring to prevent unauthorized access and encroachments',
                    ],
                    },
                ].map(({ icon, title, points }) => (
                    <div key={title} className="col-lg-3 col-md-6">
                    <div
                        className="service-card"
                        style={{
                        backgroundColor: 'white',
                        borderRadius: '10px',
                        padding: '30px',
                        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.3s ease',
                        textAlign: 'center',
                        height: '100%',
                        }}
                        onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = '0 25px 50px rgba(0, 0, 0, 0.15)';
                        e.currentTarget.style.transform = 'translateY(-8px)';
                        }}
                        onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.1)';
                        e.currentTarget.style.transform = 'translateY(0)';
                        }}
                    >
                        <div
                        style={{
                            fontSize: '3.5rem',
                            marginBottom: '20px',
                            color: '#4A90E2',
                        }}
                        aria-label={`${title} icon`}
                        role="img"
                        >
                        {icon}
                        </div>

                        <h4
                        style={{
                            fontWeight: '600',
                            fontSize: '1.4rem',
                            marginBottom: '20px',
                            letterSpacing: '0.2px',
                        }}
                        >
                        {title}
                        </h4>

                        <p
                        style={{
                            color: '#000',
                            fontSize: '17px',
                            lineHeight: '1.8',
                            margin: 0,
                        }}
                        >
                        {points[0]}
                        </p>
                    </div>
                    </div>
                ))}
                </div>
            </div>
            </section>

            <div className="why-choose-two">
                <div className="container" id='about-will'>
                    <div className="row gutter-y-30">                        
                        <div className="col-lg-5">
                            <img
                                src={securityImage}
                                alt="Why Choose The NRI Advisors"
                                className="img-fluid rounded"
                            />
                        </div>

                        <div className="col-lg-7 align-self-center">
                            <div className="why-choose-right-two">
                                <div className="heading-box heading-white">
                                    <h2 className="heading-title wow fadeInUp animated animated text-black" style={{ marginTop: '0px', paddingTop: "0px", }}>
                                        Why Choose The NRI Advisors?
                                    </h2>
                                </div>

                                <ul className='features-one-list1' style={{ display: "flex", flexDirection: "column" }}>
                                    <li><b>No Travel Needed:</b> We manage your entire process remotely</li>
                                    <li><b>One Stop Solution:</b> Legal, financial, property, and documentation under one roof</li>
                                    <li><b>Global Reach, Local Execution:</b> International support with on-ground expertise</li>
                                    <li><b>Transparent Pricing:</b> No surprises. Clear estimates and honest fees.</li>
                                    <li><b>Globally Coverage:</b> We serve across all states and union territories globally</li>
                                    <li><b>Tailored Service:</b> We customize every case to meet your specific needs</li>
                                    And more.
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            <section
                className="five-step-process"
                style={{
                    backgroundColor: '#f7f9fb',
                    padding: '60px 0',
                    fontFamily: "'DM Sans', sans-serif",
                    color: '#000',
                }}
                >
                <div className="container">
                    <h2 className="heading-title wow fadeInUp animated animated mb-5 pb-0 text-center">
                    How We Get Things Done?
                    </h2>

                    <div className="timeline d-flex flex-column gap-5">
                    {[
                        {
                        title: 'Initial Assessment',
                        text: 'We begin with a detailed consultation to understand your unique security concerns and requirements',
                        },
                        {
                        title: 'Customized Planning',
                        text: 'Based on your needs, we design a tailored security plan— personal, technical, or property-focused',
                        },
                        {
                        title: 'Expert Deployment',
                        text: 'Our trained personnel and tech teams are deployed to execute your plan with professionalism and care',
                        },
                        {
                        title: 'Real-Time Monitoring',
                        text: 'We provide live updates, surveillance reports, and instant alerts through secure communication channels',
                        },
                        {
                        title: 'Regular Follow-Ups',
                        text: 'Dedicated case managers keep you updated with weekly reports and direct coordination',
                        },
                        {
                        title: 'Confidential & Transparent Closure',
                        text: 'You receive final reports or outcomes with full transparency and data privacy',
                        },
                    ].map((step, index) => (
                        <div
                        key={index}
                        className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}
                        >
                        <div className="col-md-6">
                            <h5 style={{ fontWeight: '600', fontSize: '1.2rem' }}>
                            <span
                                style={{
                                display: 'inline-block',
                                background: '#041021fa',
                                color: '#fff',
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                textAlign: 'center',
                                lineHeight: '30px',
                                marginRight: '12px',
                                }}
                            >
                                {index + 1}
                            </span>
                            {step.title}
                            </h5>
                            <p style={{ marginTop: '10px', fontSize: '0.95rem', color: '#000' }}>{step.text}</p>
                        </div>
                        <div className="col-md-6 d-none d-md-block">
                            <div
                            style={{
                                height: '2px',
                                background: '#ddd',
                                margin: index % 2 === 0 ? '0 30px 0 0' : '0 0 0 30px',
                            }}
                            />
                        </div>
                        </div>
                    ))}
                    </div>
                </div>
            </section>

            <ContactForm />

            {/* <Servicesdetails />
            <Ctaone /> */}
            <Footer />
            {/* <BackToTop/> */}
        </>
    )
}
export default Main;